import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Page, SearchInput, Table, Text } from '@dixa/lib-shared-habla';
import Fuse from 'fuse.js';
import { useCallback, useMemo, useState } from 'react';
import { appActions } from 'app/app.actions';
import { useCommands } from 'utils/commands';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { KeyboardKeybindingsBanner } from './components/banner/keyboardKeybindingsBanner';
import { KeyboardKeybindingsTableRow } from './components/row/keyboardKeybindingsTableRow';
import styles from './keyboardKeybindingsTable.module.scss';
const minMatchCharLength = 2;
export const KeyboardKeybindingsTable = () => {
    const { enrichedCommands, resetAllUserKeybindings, unassignAllKeybindings, canResetAllRebindableKeybindings, canUnassignAllRebindableKeybindings, } = useCommands();
    const dispatch = useAppDispatch();
    const [searchTerm, setSearchTerm] = useState('');
    const filteredEnrichedCommands = useMemo(() => {
        const fuse = new Fuse(enrichedCommands, {
            keys: ['command.label', 'command.description', 'command.group'],
            threshold: 0.2,
            minMatchCharLength,
            distance: 200,
        });
        if (searchTerm.length >= minMatchCharLength) {
            const fuseResults = fuse.search(searchTerm).map(({ item }) => item);
            return fuseResults.length > 0 ? fuseResults : enrichedCommands;
        }
        return enrichedCommands;
    }, [enrichedCommands, searchTerm]);
    const showFeedbackModal = useCallback(() => {
        dispatch(appActions.showModal({
            modal: {
                type: 'app:feedbackForm',
                arg: {
                    team: 'conversations',
                    title: 'Keyboard shortcuts feedback',
                },
            },
        }));
    }, [dispatch]);
    const table = (_jsxs(Table, Object.assign({ stickyHeader: true, hoverable: true }, { children: [_jsx(Table.Thead, { children: _jsxs(Table.Tr, { children: [_jsx(Table.Th, { children: "Command" }), _jsx(Table.Th, Object.assign({ width: "200px" }, { children: "Group" })), _jsx(Table.Th, { width: "0" }), _jsx(Table.Th, Object.assign({ width: "35%" }, { children: "Keybindings" })), _jsx(Table.Th, { width: "0" })] }) }), _jsx(Table.Tbody, { children: filteredEnrichedCommands.map((enrichedCommand) => (_jsx(KeyboardKeybindingsTableRow, { enrichedCommand: enrichedCommand }, enrichedCommand.command.name))) })] })));
    return (_jsx(Page.Section, Object.assign({ title: "All keyboard shortcuts", titleMeta: _jsx("span", Object.assign({ onClick: () => showFeedbackModal() }, { children: _jsx(Text.Paragraph, Object.assign({ as: "span", variant: "4", className: styles.feedbackLink }, { children: "Send feedback" })) })), controls: _jsxs(_Fragment, { children: [_jsx(SearchInput, { onSubmit: setSearchTerm, onToggle: (isOpen) => !isOpen && setSearchTerm('') }), _jsx(Button, Object.assign({ disabled: !canResetAllRebindableKeybindings, variant: "secondary", onClick: () => resetAllUserKeybindings() }, { children: "Reset all" })), _jsx(Button, Object.assign({ disabled: !canUnassignAllRebindableKeybindings, variant: "secondary", onClick: () => unassignAllKeybindings() }, { children: "Unassign all" }))] }), callout: _jsx(KeyboardKeybindingsBanner, {}) }, { children: table })));
};
